<template>
  <div
    v-if="estimatedUsage"
    class="usage"
    data-testid="fiber-usage-container"
  >
    <p>Your usage this month:</p>
    <span data-testid="estimated-usage">${{ estimatedUsage.toFixed(2) }}</span>
  </div>
</template>

<script>
// Services
import {Graphics} from '@/services/GraphicService';
import {MapService} from '@/services/MapService';

export default {
  name: 'FiberLayerUsage',
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      layerGraphic: null,
      layerUsage: null,
    };
  },
  computed: {
    estimatedUsage() {
      // $15 threshold per user
      const showUsageThreshold = this.layer.showUsageThreshold ?? 15;
      // About $0.41 per call
      const rate = this.layer.rate ?? 0.41;
      // 15 tiles is a single call
      const usage = Math.ceil(this.layerUsage / 15) * rate;
      return usage > showUsageThreshold ? usage : 0;
    },
  },
  mounted() {
    this.layerGraphic = Graphics.getGraphic('wmtsTile', this.layer.id);
    this.layerUsage = this.layerGraphic.currentMonthUsage;
    MapService.addMapListener(`fiber-idle-${this.layer.id}`, 'idle', () => {
      // Get the latest usage when the map idles
      this.layerUsage = this.layerGraphic.currentMonthUsage;
    });
  },
  unmounted() {
    MapService.removeMapListener(`fiber-idle-${this.layer.id}`);
  },
};
</script>

<style scoped lang="scss">
p {
    color: main.$npGray;
    font-size: 14px;
    font-weight: bold;
  }
  .usage {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    span {
      color: main.$npOrange;
      font-weight: 900;
    }
  }
</style>
